import {FormControl, FormGroup, Validators} from '@angular/forms';
import {PartnerContact} from '../models/partner/partner-contact';
import {CompanyRole} from '../constants/company-role';

export abstract class ContactForm {
  static getFormGroup(companyRole: CompanyRole): FormGroup {
    return new FormGroup({
      partnerId: new FormControl(null, Validators.required),
      companyRole: new FormControl(companyRole, Validators.required),
      email: new FormControl(''),
      phoneNumber: new FormControl(''),
      civility: new FormControl(''),
      firstname: new FormControl(''),
      lastname: new FormControl(''),
      nickname: new FormControl(''),
      telegram: new FormControl(''),
      teams: new FormControl(''),
    });
  }

  static update(form: FormGroup, contact: PartnerContact): void {
    form.patchValue({
      partnerId: contact.partnerId,
      email: contact.email,
      phoneNumber: contact.phoneNumber,
      civility: contact.civility,
      firstname: contact.firstname,
      lastname: contact.lastname,
      nickname: contact.nickname,
      telegram: contact.telegram,
      teams: contact.teams,
    });
  }
}
